const initialState = {
    harryPottersCharacters: null,
    selectedCharacter: null
};

const characterReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_HARRYPOTTER_CHARACTERS":
            let newCharactersState = {
            ...state,
            harryPottersCharacters: action.harryPottersCharacters
            };
            return newCharactersState;
        case "ADD_CHARACTER":
            let newState = {
                ...state,
                selectedCharacter: action.character
            }
            return newState
      default:
        return state;
    }
};

export default characterReducer;